import React, { FunctionComponent } from "react";
import styles from "./NewsCard.module.scss";
import NewsCardProps from "./NewsCardProps.interface";
import Anchor from "components/Anchor/Anchor";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import getRelativeUrl from "helpers/getRelativeUrl";
import getImageCrop from "app/media/helpers/getImageCrop";
import Moment from "react-moment";

const NewsCard: FunctionComponent<NewsCardProps> = (props) => {
    const imageCrop = getImageCrop(props.image?.umbracoFile.crops, undefined, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, props.image?.umbracoWidth, props.image?.umbracoHeight);

    return (
        <Anchor className={styles.wrapper} to={getRelativeUrl(props._url)}>
            <div className={styles.inner}>
                <div className={styles.media}>
                    {props.image ? (
                        <ImageViewer className={styles.image} src={props.image.umbracoFile.src} focalPoint={props.image.umbracoFile.focalPoint} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                    ) : null}
                </div>

                <div className={styles.content}>
                    {props.date ? (
                        <p className={styles.date}>
                            <Moment parse="YYYY-MM-DDTHH:mm:ss" format="DD. MMM YYYY">{props.date}</Moment>
                        </p>
                    ) : null}

                    <h4 className={styles.headline}>{props.title}</h4>

                    {props.description ? (
                        <p className={styles.text}>{props.description}</p>
                    ) : null}
                </div>
            </div>
        </Anchor>
    );
};

export default NewsCard;